import React, { useEffect } from 'react';
import { initMetaPixel } from './components/meta-pixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark text-zinc-100 font-sans selection:bg-brand-orange/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Story data-id="element-4" />
        <Testimonials data-id="element-5" />
        <Offer data-id="element-6" />
        <FAQ data-id="element-7" />
        <Guarantee data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}